"use client"
import PrimaryButton from "@/components/buttons/PrimaryButton"
import Image from "@/components/images/Image"
import { CallToActionBanner } from "@/components/sections"
import { BodySmall, Heading1 } from "@/components/text"
import { useRouter } from "next/navigation"

export interface BaseErrorProps {
  code?: string
}

const ErrorPage: React.FC<BaseErrorProps> = ({ code }) => {
  const router = useRouter()

  const renderHeader = () => {
    let id = "error_unknown_title"
    let defaultMessage = "Er is een fout opgetreden"
    let description = "error occurred."

    switch (code) {
      case "404":
        id = "error_404_title"
        defaultMessage = "Doet niet't exist!"
        description = "Deze pagina bestaat niet"
        break
      case "410":
        defaultMessage = "Service niet beschikbaar"
        id = "error_410_title"
        description = "Deze pagina is niet meer beschikbaar."
        break
      case "429":
        id = "error_429_title"
        defaultMessage = "To many requests"
        description = "these"
        break
      case "503":
        id = "error_503_title"
        defaultMessage = "Error is opgetreden"
        description = "We weten niet wat er is gebeurd, maar zullen snel terugkomen"
        break
      case "9999":
        id = "error_9999_title"
        defaultMessage = "Er ging iets verkeerd"
        description = "Er ging iets verkeerd"
        break
    }
    return defaultMessage
  }

  const renderMessage = () => {
    let id = "error_unknown"
    let defaultMessage = "Er is iets fout gegaan! Probeer het later opnieuw of neem contact op met hello@goodshift.nl"
    let description = "Onbekende fout"

    switch (code) {
      case "404":
        id = "error_404"
        defaultMessage = "Deze pagina bestaat niet"
        description = "Deze pagina bestaat niet"
        break
      case "410":
        id = "error_410"
        defaultMessage = "Deze actie of liefdadigheid is niet langer beschikbaar"
        description = "De gevraagde actie of liefdadigheid is niet langer beschikbaar"
        break
      case "429":
        id = "error_429"
        defaultMessage = "To many requests"
        description = "these"
        break
      case "503":
        id = "error_503"
        defaultMessage = "Sorry, onze service is tijdelijk niet beschikbaar. We doen al ons best om snel terug te komen"
        description = "Sorry, onze service is tijdelijk niet beschikbaar. We doen al ons best om snel terug te komen"
        break
      case "9999":
        id = "error_9999"
        defaultMessage = "Probeer het opnieuw of pas je betaal gegevens aan."
        description = "Probeer het opnieuw of pas je betaal gegevens aan."
        break
    }
    return defaultMessage
  }

  return (
    <>
      <div className="px-4 mx-auto max-w-7xl">
        <div className="flex flex-col bg-white w-full text-center">
          <Image
            className="m-auto"
            src={"/goodshift/img/icons/error_orange.svg"}
            height={120}
            width={120}
            alt="Error!"
          />
          <Heading1>{renderHeader()}</Heading1>
          <BodySmall>{renderMessage()}</BodySmall>
          <div className="px-12 mb-12">
            <PrimaryButton
              onClick={() => {
                router.back()
              }}>
              <Image src={"/goodshift/img/icons/hand_heart_white.svg"} height={24} width={24} alt="" />
            </PrimaryButton>
          </div>
          <CallToActionBanner />
        </div>
      </div>
    </>
  )
}
export default ErrorPage
